import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'overviewSingleGroup',
    label: 'Overview Report Single Group',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
